/* === momentprints | Cart Shipping Info ABOVE express payment buttons === */
(() => {
  const DAYS_AFTER_TODAY = 3;

  const formatDate = (date) => {
    const w = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
    const m = ["Jan.", "Feb.", "Mär.", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."];
    return `${w[date.getDay()]}., ${date.getDate()}. ${m[date.getMonth()]}`;
  };

  const createNode = () => {
    const d = new Date();
    d.setDate(d.getDate() + DAYS_AFTER_TODAY);

    const el = document.createElement("div");
    el.className = "mp-shipping-info";
    el.setAttribute("role", "note");
    el.innerHTML = `
  <span class="mp-shipping-left">
    <span class="mp-shipping-dot" aria-hidden="true"></span>
    <span>Versand am <strong>${formatDate(d)}</strong></span>
  </span>

  <span class="mp-shipping-right">
    <span class="mp-flag-de" aria-hidden="true">🇩🇪</span>
    <span class="mp-shipping-strong">Premium Versand</span>
  </span>
`;

    return el;
  };

  // Express-Payment-Block (Shop Pay / PayPal / GPay) – Dawn-typische Selektoren
  const findExpressAnchor = () =>
    document.querySelector(
      ".dynamic-checkout__content, .cart__dynamic-checkout-buttons, .shopify-cleanslate [data-testid='ShopifyPayButton'], .shopify-cleanslate"
    );

  // Fallback-Ziele, falls express block gerade (noch) nicht gerendert ist
  const findFallbackTarget = () =>
    document.querySelector("#main-cart-footer, .cart__footer, main-cart-footer, .cart-drawer__footer, .drawer__footer");

  const insert = () => {
    // Wenn schon drin, nicht doppeln
    if (document.querySelector(".mp-shipping-info")) return;

    const anchor = findExpressAnchor();
    const node = createNode();

    if (anchor && anchor.parentElement) {
      // WICHTIG: vor dem Express-Block einfügen (also "oberhalb der payment icons")
      anchor.insertAdjacentElement("afterend", node);
      return;
    }

    // Fallback: oben in den Footer
    const fallback = findFallbackTarget();
    if (fallback) fallback.prepend(node);
  };

  const boot = () => {
    insert();

    // bei Cart-AJAX/Drawer neu rendern -> nachfassen
    let tries = 0;
    const iv = setInterval(() => {
      insert();
      tries += 1;
      if (document.querySelector(".mp-shipping-info") || tries > 60) clearInterval(iv);
    }, 200);

    new MutationObserver(insert).observe(document.body, { childList: true, subtree: true });
  };

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot)
    : boot();
})();
